/**
 * P1-03 · Product-media input shapes. `template:core` — ordering, primary
 * selection, and variant-image assignment behave identically for every brand.
 */
import { z } from "zod";

/** A single hero/PDP video URL — http(s) only; embed-host allow-list is P3. */
export const videoUrlSchema = z
  .string()
  .url()
  .refine((u) => /^https?:\/\//i.test(u), "must be an http(s) URL");

export const attachInputSchema = z.object({
  productId: z.string(),
  mediaAssetIds: z.array(z.string()).min(1),
});

export const detachInputSchema = z.object({
  productId: z.string(),
  mediaAssetId: z.string(),
});

export const reorderInputSchema = z.object({
  productId: z.string(),
  orderedIds: z.array(z.string()).min(1),
});

export const setPrimaryInputSchema = z.object({
  productId: z.string(),
  mediaAssetId: z.string(),
});

export const setVariantImageInputSchema = z.object({
  variantId: z.string(),
  // null clears the variant's image.
  mediaAssetId: z.string().nullable(),
});

export const setVideoInputSchema = z.object({
  productId: z.string(),
  videoUrl: videoUrlSchema.nullable(),
});
